import { useLocation } from 'react-router-dom';
import { Group, Text } from '@mantine/core';
import { Eye } from 'lucide-react';
import { usePermissions } from '@contexts/PermissionsContext';
import { useTheme } from '@contexts/ThemeContext';

/**
 * A one-line ribbon on any page whose menu was granted as "Lihat saja".
 *
 * Without it a read-only user meets the restriction only as a failed action:
 * the API refuses the write and a toast explains it after the fact. Saying so
 * up front is the difference between a rule and a bug.
 */
export default function ReadOnlyNotice() {
  const { pathname } = useLocation();
  const { accessLevel } = usePermissions();
  const { colors: themeColors } = useTheme();

  if (accessLevel(pathname) !== 'read') return null;

  return (
    <Group
      gap={8}
      wrap="nowrap"
      px="md"
      py={8}
      style={{
        backgroundColor: themeColors.card,
        borderBottom: `1px solid ${themeColors.border}`,
      }}
    >
      <Eye size={15} style={{ color: themeColors.textSecondary, flexShrink: 0 }} />
      <Text size="xs" style={{ color: themeColors.textSecondary }}>
        Role Anda hanya bisa <b>melihat</b> menu ini. Anda dapat membuka dan mengunduh data, tetapi tidak dapat membuat,
        mengubah, mengirim, atau menghapus.
      </Text>
    </Group>
  );
}

export { ReadOnlyNotice };
